<template>
    <div class="home">
        <ListArticles :articles="articles"> </ListArticles>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ListArticles from '@/components/ListArticles.vue';

export default {
    name: 'Home',
    components: {
        ListArticles,
    },
    computed: mapState(['articles']),
    created() {
        this.loadArticles();
    },
    methods: {
        ...mapActions(['loadArticles']),
    },
};
</script>
